import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationBlock } from '../../components/notification-block/notification-block';

@Component({
  selector: 'app-display-page',
  imports: [RouterOutlet, NotificationBlock],
  templateUrl: './display-page.html',
  styleUrl: './display-page.scss',
})
export class DisplayPage {}
